import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

export interface AttachmentDto {
  id: string;  // Guid -> string in TypeScript
  titleAr: string;
  titleEn: string;
  pdfUrlAr: string;
  pdfUrlEn: string;
}

@Component({
  selector: 'app-pdf-preview',
  templateUrl: './pdf-preview-dialog.component.html',
  styleUrls: ['./pdf-preview-dialog.component.css']
})
export class PdfPreviewDialogComponent implements OnInit {

  @Input() attachment?: AttachmentDto;
  safePdfUrl!: SafeResourceUrl;
  isLoading: boolean = true;
  title?: string = '';
  private fileUrl?: string;

  constructor(
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.title =  this.attachment?.titleEn;
    this.fileUrl =this.attachment?.pdfUrlEn;
    //window.open(fileUrl, '_blank');

    const googleDocsViewer = 'https://docs.google.com/viewer?url=';
    const embeddedParam = '&embedded=true';
    this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      googleDocsViewer + encodeURIComponent(this.fileUrl || '') + embeddedParam
    );


    // Add content type to force PDF display
    //const pdfUrl = `${this.pdfUrl}#toolbar=0&navpanes=0&view=FitH`;
    // this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfUrl);
    // Use PDF.js viewer instead of Google Docs
    //const pdfViewerUrl = `/assets/pdfjs/web/viewer.html?file=${encodeURIComponent(this.pdfUrl)}`;
    //this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfViewerUrl);

  }

  onIframeLoad() {
    this.isLoading = false;
  }

  downloadPdf() {
    if (this.fileUrl) {
      window.open(this.fileUrl, '_blank');
    }
  }
}